import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { PhysioReviewContext } from "./PhysioReviewFormProvider";
import {
  getLatestPhysioReviewAPI,
  getPhysioInspectionAPI,
  getPhysioReviewAPI,
  physioReviewAPI,
  updatePhysioReviewAPI,
} from "../../../../services/physio.services";
import {
  Button,
  Col,
  Drawer,
  Form,
  Image,
  message,
  Row,
  Spin,
  Tabs,
  Tag,
  Typography,
  theme,
} from "antd";
import { LeftOutlined } from "@ant-design/icons";
import PhysioScales from "../../InspectionForms/Examination/PhysioScales/PhysioScales";
import PhysioFunctionalDiagnosisReview from "../../InspectionForms/FunctionalDiagnosis/PhysioFunctionalDiagnosisReview";
import PhysioTreatmentPlanReview from "../../InspectionForms/TreatmentPlan/PhysioTreatmentPlanReview";
import bedImg from "../../../../assets/images/patientIcons/bed.svg";
import "../../ipforms.css";
import "../../Doctor/InitialInspection/InitialInspectionHeader.css";
import { appConfirmModal } from "../../../../helpers/appConfirmModal";

const reviewTabs = [
  { key: "1", label: "Functional Diagnosis" },
  { key: "2", label: "Scales" },
  { key: "3", label: "Treatment Plan" },
];

const PhysioReviewForm = ({
  editId,
  visible,
  setVisible,
  refreshPage,
  iAssessment,
  addMode,
  setAddMode,
  setActiveSegment,
  reviewData,
  setDailyReviewRefresh,
  dailyRefresh,
  segmentData,
  patientData,
}) => {
    const { token } = theme.useToken();
  const location = useLocation();
  const params = Object.fromEntries(new URLSearchParams(location?.search));
  const [triggerScaleSave, setTriggerScaleSave] = useState(false);
const [nextMainTab, setNextMainTab] = useState(null);
  const [isScaleDirty, setIsScaleDirty] = useState(false);
  const [diagnosisForm] = Form.useForm();
  const [scalesForm] = Form.useForm();
  const [treatmentForm] = Form.useForm();
  const { formData, setFormData } = useContext(PhysioReviewContext);
  const [activeTab, setActiveTab] = useState("1");
  const [isDirty, setIsDirty] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const newReview = reviewData?.length === 0;
  const reviewId = reviewData?.[0]?.id;
  const newReviewId = addMode === false && reviewId ? reviewId : null;
  const reviewDate =
    segmentData?.find(
      (option) => option.value === editId && option.value !== "others"
    )?.label ||
    new Date().toLocaleDateString("en-US", { month: "short", day: "2-digit" });
  const [scalesId, setScalesId] = useState({});
  const [scaleTab, setScaleTab] = useState("1");
  const reviewBodyRef = useRef(null);
  const scaleNavRef = useRef(null);
  const scaleLabelByTab = {
  "1": "GCS",
  "2": "NIHSS",
  "3": "MOCA",
  "4": "RASS",
  "5": "ASIA",
  "6": "VAS",
  "7": "MAS",
  "8": "MMT",
  "9": "ROM",
  "10": "VCG",
  "11": "RPE",
  "12": "Reflexes",
  "13": "Peak Flow Meter Test",
  "14": "Six Minute Walk Test",
  "15": "Coordination",
  "16": "TCM",
  "17": "Finger Grip Test",
  "18": "Barthel Index",
};
  const showUnsavedModal = ({ onSave, onDiscard }) => {
  appConfirmModal({
    title: "Unsaved changes",
    content: <div style={{ marginTop: 12 }}>Do you want to save before leaving?</div>,
    okText: "Save",
    cancelText: "Close",
    width: 420,
    centered: true,
    bodyStyle: { padding: "20px 24px 16px" },

    okButtonProps: {
      style: {
        background: token.colorPrimary,
        borderColor: token.colorPrimary,
        color: "#fff",
        fontWeight: 500,
      },
    },

    cancelButtonProps: {
      style: {
        height: 34,
        padding: "0 18px",
      },
    },

    onOk: onSave,
    onCancel: onDiscard,
  });
};
  const handleSubmit = async (values, flag) => {
    try {
      if (editId || newReviewId) {
        await updatePhysioReviewAPI(editId || newReviewId, values);
        setDailyReviewRefresh();
      } else {
        await physioReviewAPI(values);
        refreshPage();
        setAddMode(false);
        setDailyReviewRefresh();
      }

      if (flag !== "Scales") {
    message.success(`${flag} submitted successfully`);
  }

      setIsDirty(false);
    } catch (error) {
      message.error(error?.response?.data?.message || "Something went wrong");
      if (flag === "Scales") {
        throw error;
      }
    }
  };

  const onDiagnosisSubmit = async (values) => {
    return await handleSubmit(
    {
      ...formData,
      functional_diagnosis: values,
      admission_id: params?.patient,
    },
    "Functional Diagnosis"
  );
};
const onScalesSubmit = async (values, meta = {}) => {
  await handleSubmit(
    {
      ...formData,
      scales: values,
      admission_id: params?.patient,
    },
    "Scales"
  );

  const label = scaleLabelByTab[scaleTab] || "Scale";
  const isUpdate = Boolean(meta?.isUpdate);
  message.success(
    `${label} ${isUpdate ? "updated" : "saved"} successfully`
  );
  setIsScaleDirty(false);

  if (nextMainTab) {
    setActiveTab(nextMainTab);
    setNextMainTab(null);
  }

  setTriggerScaleSave(false);
};
  const onTreatmentSubmit = async (values) => {
   return await handleSubmit(
      {
        ...formData,
        treatment_plan: values,
        admission_id: params?.patient,
      },
      "Treatment Plan"
    );
  };

  const openEdit = async () => {
    setDataLoading(true);
    try {
      if (editId && newReview === false) {
        const response = await getPhysioReviewAPI(editId);
        setFormData(response?.data?.data);
        setScalesId(response?.data?.data?.scales);
      } else if (newReview === false) {
        const response = await getLatestPhysioReviewAPI(params?.patient);
        const { scales, ...rest } = response?.data?.data;
        setFormData(rest);
      } else {
        const response = await getPhysioInspectionAPI(iAssessment);
        setFormData(response.data.data);
      }
    } catch (error) {
      console.log(`Error: ${error}`);
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    openEdit();
  }, [editId]);
useEffect(() => {
  if (activeTab !== "2") {
    setIsScaleDirty(false);
  }
}, [activeTab]);

  useEffect(() => {
    if (reviewBodyRef.current) {
      reviewBodyRef.current.scrollTop = 0;
    }
  }, [activeTab]);
  const getFormKey = async () => {
  switch (activeTab) {
    case "1":
      const dValues = await diagnosisForm.validateFields();
      await onDiagnosisSubmit(dValues); 
      break;

    case "2":
      const sValues = await scalesForm.validateFields();
      await onScalesSubmit(sValues); 
      break;

    case "3":
      const tValues = await treatmentForm.validateFields();
      await onTreatmentSubmit(tValues); 
      break;

    default:
      break;
  }
};

  const handleTabChange = (key) => {
    if (activeTab === "2" && isScaleDirty) {
    showUnsavedModal({
      onSave: async () => {
      setNextMainTab(key);    
      setTriggerScaleSave((prev) => !prev);
      },
      onDiscard: () => {
        setIsScaleDirty(false);
        setActiveTab(key);
      },
    });
    return;
  }
  if (isDirty) {
    showUnsavedModal({
      onSave: async () => {
  try {
    await getFormKey(); 
    setIsDirty(false);
    setActiveTab(key);
  } catch (e) {
  }
},
      onDiscard: () => {
        setIsDirty(false);
        setActiveTab(key);
      },
    });
  } else {
    setActiveTab(key);
  }
    // if (isDirty) {
    //   switch (activeTab) {
    //     case "1":
    //       diagnosisForm.validateFields().then((values) => {
    //         setIsDirty(false);
    //         onDiagnosisSubmit(values);
    //         setActiveTab(key);
    //       });
    //       break;
    //     case "2":
    //       scalesForm.validateFields().then((values) => {
    //         setIsDirty(false);
    //         onScalesSubmit(values);
    //         setActiveTab(key);
    //       });
    //       break;
    //     case "3":
    //       treatmentForm.validateFields().then((values) => {
    //         setIsDirty(false);
    //         onTreatmentSubmit(values);
    //         setActiveTab(key);
    //       });
    //       break;
    //     default:
    //       setActiveTab(key);
    //   }
    // } else {
    //   setActiveTab(key);
    // }
  };

  const onFormValuesChange = () => {
    setIsDirty(true);
  };

  const patientName = `${patientData?.admission?.patient?.first_name || ""} ${
    patientData?.admission?.patient?.last_name || ""
  }`.trim();

  const handleCloseConfirm = () => {
    appConfirmModal({
      title: "Confirmation",
      content: "Are you sure you want to close without saving ?",
      okButtonProps: {
        style: {
          background: token.colorPrimary,
          borderColor: token.colorPrimary,
          color: "#fff",
          fontWeight: 500,
        },
      },
      onOk: () => {
        setVisible(false);
        setActiveSegment(reviewData[0]?.id);
      },
    });
  };

  return (
    <div>
      <Drawer
        className="physioreview-drawer"
        styles={{
          body: {
            overflow: "hidden",
            paddingTop: 0,
            paddingBottom: 0,
            paddingInline: 24,
            display: "flex",
            flexDirection: "column",
            height: "100%",
          },
        }}
        open={visible}
        width="100%"
        title={
          <div className="ia-drawer-header">
            <div className="ia-drawer-header__main">
              <LeftOutlined
                className="ia-drawer-header__back"
                onClick={handleCloseConfirm}
              />
              <div className="ia-drawer-header__identity">
                <div className="ia-drawer-header__name-row">
                  <Typography.Text
                    className="ia-drawer-header__name"
                    ellipsis={{ tooltip: patientName }}
                  >
                    {patientName}
                  </Typography.Text>
                  {patientData?.admission?.bed?.bed_no && (
                    <Tag color="orange" className="ia-drawer-header__bed">
                      <Image src={bedImg} preview={false} width={12} />{" "}
                      {patientData?.admission?.bed?.bed_no}
                    </Tag>
                  )}
                </div>
                <div className="ia-drawer-header__meta">
                  <Tag className="ia-drawer-header__tag">
                    {patientData?.admission?.patient?.age_by_dob ||
                      patientData?.admission?.patient?.age}{" "}
                    {patientData?.admission?.patient?.gender}
                  </Tag>
                  <Tag className="ia-drawer-header__tag">
                    IP ID: {patientData?.admission?.ip_id}
                  </Tag>
                  {reviewDate && (
                    <Tag className="ia-drawer-header__tag">{reviewDate}</Tag>
                  )}
                </div>
              </div>
            </div>
          </div>
        }
        footer={null}
        onClose={() => {
          setVisible(false);
          setActiveSegment(reviewData[0]?.id);
        }}
        closeIcon={null}
        keyboard={false}
      >
        <div className="physio-review-form-shell">
          <div className="ia-form-tabs physio-review-form-tabs">
            <Row>
              <Col
                xs={24}
                sm={24}
                md={{ span: 23, offset: 1 }}
                lg={{ span: 21, offset: 3 }}
                xl={{ span: 19, offset: 5 }}
                xxl={{ span: 18, offset: 6 }}
              >
                <Tabs
                  activeKey={activeTab}
                  items={reviewTabs}
                  onChange={handleTabChange}
                />
              </Col>
            </Row>
          </div>

          <div className="ia-form-panel">
            <div
              className={`ia-form-body physio-review-inner${
                activeTab === "2" ? " physio-review-scales" : ""
              }`}
              ref={reviewBodyRef}
            >
              <Spin
                spinning={dataLoading}
                tip="Loading review data..."
                className="physio-review-spin"
              >
                {activeTab === "1" && (
                  <Form
                    id="daily-review-functional-diagnosis"
                    form={diagnosisForm}
                    layout="vertical"
                    onFinish={onDiagnosisSubmit}
                    onValuesChange={onFormValuesChange}
                    initialValues={formData}
                    className="ip-forms ip-forms-review"
                  >
                    <PhysioFunctionalDiagnosisReview form={diagnosisForm} />
                  </Form>
                )}

                {activeTab === "2" && (
                  <PhysioScales
                    admission={params?.patient}
                    reviewData={reviewData}
                    editId={editId}
                    onScalesSubmit={onScalesSubmit}
                    scalesId={scalesId}
                    setScalesId={setScalesId}
                    setActiveTab={setActiveTab}
                    scaleTab={scaleTab}
                    setScaleTab={setScaleTab}
                    setVisible={setVisible}
                    onClose={() => {
                      setIsScaleDirty(false);
                      setVisible(false);
                      setActiveSegment(reviewData[0]?.id);
                    }}
                    patientData={patientData?.admission?.patient}
                    isScaleDirty={isScaleDirty}
                    setIsScaleDirty={setIsScaleDirty}
                    triggerScaleSave={triggerScaleSave}
                    setTriggerScaleSave={setTriggerScaleSave}
                    nextMainTab={nextMainTab}
                    setNextMainTab={setNextMainTab}
                    scaleNavRef={scaleNavRef}
                  />
                )}

                {activeTab === "3" && (
                  <Form
                    id="daily-review-treatment-plan"
                    form={treatmentForm}
                    layout="vertical"
                    onFinish={onTreatmentSubmit}
                    onValuesChange={onFormValuesChange}
                    initialValues={formData}
                    className="ip-forms ip-forms-review"
                  >
                    <PhysioTreatmentPlanReview form={treatmentForm} />
                  </Form>
                )}
              </Spin>
            </div>

            <div className="ia-form-footer physio-review-footer">
              {activeTab === "2" ? (
                <>
                  <Button
                    onClick={() => scaleNavRef.current?.saveClose?.()}
                  >
                    Save & Close
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => scaleNavRef.current?.saveProceed?.()}
                  >
                    {scaleTab === "18" ? "Done" : "Save & Proceed"}
                  </Button>
                </>
              ) : (
                <>
                  {activeTab !== "3" && (
                    <Button
                      onClick={() => {
                        getFormKey();
                        setVisible(false);
                      }}
                    >
                      Save & Close
                    </Button>
                  )}
                  <Button
                    onClick={() => {
                      getFormKey();
                      if (reviewBodyRef.current) {
                        reviewBodyRef.current.scrollTop = 0;
                      }
                      const nextTab = (parseInt(activeTab) + 1).toString();
                      if (activeTab === "3") {
                        setVisible(false);
                      } else {
                        setActiveTab(nextTab);
                      }
                    }}
                    type="primary"
                  >
                    {activeTab === "3" ? "Done" : "Save & Proceed"}
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default PhysioReviewForm;
